import * as comUtils from "common/utils";
export * from "common/utils";


export function parseResponse(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  return response;
}

export function convertCentsToAmount(cents) {
  if (!cents) return 0;
  return (cents / 100.0).toFixed(2);
}

export function convertCentsToFloat(cents) {
  return parseFloat(convertCentsToAmount(cents));
}

export function getAddedCartItemIds(existingMapper, currentMapper) {
  let addedIds = [];

  for (var id in currentMapper) {
    let currentQuantity = currentMapper[id];

    if (!(id in existingMapper)) {
      if (!addedIds.includes(id)) addedIds.push(id);
      continue;
    }

    let existingQuantity = existingMapper[id];
    if (currentQuantity > existingQuantity) {
      if (!addedIds.includes(id)) addedIds.push(id);
      continue;
    }
  }

  return addedIds;
}

export function dispatchAddCartItemEvent(item) {
  let event = new CustomEvent("ov_add_cart_item", {detail: item});
  document.dispatchEvent(event);
}

export function dispatchCartUpdateEvent(response) {
  let event = new CustomEvent("ov_cart_update", {detail: response});
  document.dispatchEvent(event);
}

export function getExistingCartResponse() {
  let platform = comUtils.getEcommercePlatform();
  let response = null;
  if (window.OnVoardEventsData) {
    response = window.OnVoardEventsData[`${platform}_cart`] || null;
  }

  return response;
}
